export const EMPTY_NUMBER_ID = -1
export const EMPTY_STRING_ID = '__EMPTY__'
export const MAX_REQUEST_NUMBER = 1000000
export const MAX_LOGO_SIZE = 1048576
export const CURRENT_SERVICE_TYPE: common.ServiceSubjectType = 'SCIENCEFLAT'

export const downloadOptions = [
  {
    id: 'ELEMENT',
    text: '문제지',
  },
  {
    id: 'QUICK_ANSWER',
    text: '빠른정답',
  },
  {
    id: 'ANSWER_SOLUTION',
    text: '정답해설',
  },
  {
    id: 'OMR',
    text: 'OMR',
  },
] as const

export const 가상학생목록 = {
  더하기못하는요하네스: {
    name: '더하기못하는요하네스',
    grade: 1,
    schoolType: 'ELEMENTARY',
    attendanceCode: '7777',
  },
  삼각형못그리는피타고라스: {
    name: '삼각형못그리는피타고라스',
    grade: 1,
    schoolType: 'MIDDLE',
    attendanceCode: '8888',
  },
  곱하기틀리는유클리드: {
    name: '곱하기틀리는유클리드',
    grade: 1,
    schoolType: 'HIGH',
    attendanceCode: '9999',
  },
} as const
export const 김과외_가상학생목록 = {
  삼각형못그리는피타고라스: {
    name: '삼각형못그리는피타고라스',
    grade: 1,
    schoolType: 'MIDDLE',
    attendanceCode: '8888',
  },
} as const
